export const updateFormFieldsRecursive = (data, updatedFields, parentId) => {
  if (!parentId) return updatedFields;

  return data?.map((field) => {
    if (field.property.id === parentId)
      return {
        ...field,
        children: updatedFields,
      };

    if (!field.children) return field;

    return {
      ...field,
      children: updateFormFieldsRecursive(
        field.children,
        updatedFields,
        parentId
      ),
    };
  });
};
